'use strict';

function cleanWooRankLinks () {
  $('a[href*="/woorank.com"], a[href*=".woorank.com"]').attr('href', '');
  $('a[href^="/"]').remove();
}

module.exports = cleanWooRankLinks;
